import Ls from './ls'

export default {
    async login(loginData) {
        try {
            let response = await axios.post('/api/auth/login', loginData)

            if (!!response.data.deactivated) {
                toastr['error']('Пользователь деактивирован!', 'Ошибка');
            } else {
                Ls.set('auth.token', response.data.token);
                // toastr['success']('Logged In!', 'Success');
                return response.data.token
            }
        } catch (error) {
            if (error.response.status && error.response.status === 401) {
                // toastr['error']('Invalid Credentials', 'Error')
                toastr['error']('Ошибка входа', 'Ошибка')
            } else {
                // Something happened in setting up the request that triggered an Error
                console.log('Ошибка', error.message)
            }
        }
    },

    async logout() {
        try {
            await axios.get('/api/auth/logout');

            Ls.remove('auth.token');
            Vue.prototype.$currentUser = null;

            // toastr['success']('Logged out!', 'Success')
        } catch (error) {
            console.log('Ошибка', error.message)
        }
    },

    async check() {
        let response = await axios.get('/api/auth/check');

        return response.data

    },

    async getCurrentUser() {
        let response = await axios.get('/api/auth/user');

        if (!!response.data.deactivated) {
            if (window.location.pathname != '/login') {
                return window.location.href = '/login';
            }
        } else if (response.data && response.data.user && response.data.user.deactivated === 1) {
            if (window.location.pathname != '/login') {
                return window.location.href = '/login';
            }
        } else {
            return response.data;
        }
    }
}



// WEBPACK FOOTER //
// ./resources/js/services/auth.js